import React from 'react';
import OneRecurring from 'assets/icons/one-recurring.svg';
import InfiniteRecurring from 'assets/icons/infinite-recurring.svg';
import { useUserContext } from 'UserContext';
import { getPricingPlan } from 'shared';

export type OptionType = {
    title: string;
    subtitle: string;
    highlight: string;
    listItems?: string[];
    icon?: JSX.Element;
    cardItems?: { backgroundColor: string; text: string }[];
    option: string;
};

export function usePaymentOptions() {
    const { user, getDisplayText } = useUserContext();
    const pricingPlan = getPricingPlan(user);
    return [
        {
            title: `Short-Term`,
            subtitle: `${getDisplayText('substitutes').capitalize()} (one-time or short-term)`,
            highlight: `${pricingPlan?.hourly_value || 35}% fee when you pay your worker`,
            option: 'SUBSTITUTE',
            icon: <OneRecurring />,
        },
        {
            title: `Trial Run`,
            subtitle: 'Temp-to-permanent part/full-time workers',
            highlight: `${pricingPlan?.hourly_value || 35}% hourly fee ${
                pricingPlan ? `for a trial period of ${pricingPlan.trial_run_hours} hours` : 'during the trial period'
            }`,
            option: 'TRIAL_RUN',
            icon: <InfiniteRecurring />,
        },
    ];
}
